import { isDomContentLoaded } from '../../../../modules/get_perfomance'
import { getQueryParamAll } from '../../../../modules/get_query'
import { set_redirect404 } from '../../../../modules/set_redirectUrl'
import { getCode } from '../../../../modules/get_code'

import apiPathname from '../../../../json/apiPathname.json'

import buildSidebarRound from '../../common/buildSidebarRound'
import buildTournament from '../../common/buildTournament'
import buildMigratoryRace from './buildMigratoryRace'
import buildSeasonPaging from '../../common/buildSeasonPaging'
import buildRunDateInfo from '../../common/buildRoundDateInfo'
import buildRacePanels from './buildRacePanels'

export default () => {

  const queryObject = getQueryParamAll();
  const init = () => {
    queryObject.tournament = getTournamentClassification();
    console.log(queryObject);

    const worker = new Worker('/assets/js/data/worker/api_thread_round.js');
    const postData = Object.assign({queryObject}, apiPathname, window.pist6);
    postData.getTournament = true;

    // console.log(postData);
    worker.postMessage(postData);
    worker.addEventListener('message', evt => {
      // データなし（該当データなし）の場合にリダイレクト
      if (evt.data.type == 'error') {
        set_redirect404();
        return;
      }

      if (isDomContentLoaded()) {
        processFunction[evt.data.type](evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          processFunction[evt.data.type](evt.data);
        })
      }
    })
  }

  const processFunction = {
    base: (data) => {
      console.log('base', data);

      data.page.tournament = queryObject.tournament;
      buildSeasonPaging(data.season);
      buildSidebarRound(data.round, data.page);
      buildTournament(data.tournament, data.page);
      buildMigratoryRace(data.migratoryRaces, data.page.isAllRaceComingSoon, data.page.isAllRaceDiscontinuation);

      buildRunDateInfo(data.runDateInfo, data.page.isAllRaceDiscontinuation);
      buildRacePanels(data.racePanels, data.page);

      buildKvTitle(data.page)

      document.getElementById('sidebar-league').buildSidebar();
      document.getElementById('migratory').buildMigratory();
    }
  }

  const buildKvTitle = (pageData) => {
    const kvTtl = document.querySelector('.le-header__ttl');
    kvTtl.querySelector('.le-header__ttl-main').textContent = getCode('seasonText', pageData.season).ja || 'ー';
    const ttlSub = kvTtl.querySelector('.le-header__ttl-sub');
    const ttlSubTxt = ttlSub.textContent
    ttlSub.textContent = ttlSubTxt.replace('XX-XX', pageData.yearTxt);

    kvTtl.classList.remove('_skelton');
    kvTtl.removeAttribute('aria-hidden');
  }

  const getTournamentClassification = () => {
    const pathnameArr = location.pathname.split('/');
    const leagueStrFindIndex = pathnameArr.findIndex(path => `league` == path);
    return pathnameArr[leagueStrFindIndex + 1];
  }

  init();
}
